module.exports = __webpack_public_path__ + "img/guinea.d5ae0b43.png";